import { Link } from 'react-router';

import type { SurfaceSlotV1 } from '~/api/v1/mall/surface/surface-name';

export type EventBannerItemStyles = {
  box: string;
};

type Props = {
  styles: EventBannerItemStyles;
  surfaceSlot: SurfaceSlotV1;
};

export const EventBannerItem = (props: Props) => {
  const { styles, surfaceSlot } = props;

  const type = surfaceSlot.slot_type;
  let path: string | undefined;
  if (type === 'shop') {
    path = `/shop/${surfaceSlot.campaign_id}`;
  } else if (type === 'feature') {
    path = `/event/${surfaceSlot.event_id}`;
  } else if (type === 'external') {
    path = `${surfaceSlot.external_url}`;
  }
  const imgSrc = surfaceSlot.image1_path ?? '/images/common/noimage.jpg';
  const imgAlt = surfaceSlot.title ?? 'no-title';

  if (type === 'other' || !path) {
    return <img className={styles.box} src={imgSrc} alt={imgAlt} />;
  }

  return (
    <Link
      to={path}
      className={styles.box}
      target={type === 'external' ? '_blank' : undefined}
      rel={type === 'external' ? 'noopener noreferrer' : undefined}>
      <img src={imgSrc} alt={imgAlt} />
    </Link>
  );
};
